import { useQuery } from "@tanstack/react-query";

import { fetchMobileApps, fetchMobileAppById } from "./mobile-apps.api";

export const MOBILE_APPS_QUERY_KEYS = {
  all: ["mobile-apps"] as const,
  lists: () => [...MOBILE_APPS_QUERY_KEYS.all, "list"] as const,
  list: (workspaceId?: number | string) =>
    [...MOBILE_APPS_QUERY_KEYS.lists(), { workspaceId }] as const,
  details: () => [...MOBILE_APPS_QUERY_KEYS.all, "detail"] as const,
  detail: (id: number | string, workspaceId?: number | string) =>
    [...MOBILE_APPS_QUERY_KEYS.details(), id, { workspaceId }] as const,
};

export const useMobileApps = (workspaceId?: number | string, options = {}) => {
  return useQuery({
    queryKey: MOBILE_APPS_QUERY_KEYS.list(workspaceId),
    queryFn: () => fetchMobileApps(workspaceId),
    ...options,
  });
};

export const useMobileAppDetails = (
  id?: number | string,
  workspaceId?: number | string,
  options = {},
) => {
  return useQuery({
    queryKey: MOBILE_APPS_QUERY_KEYS.detail(id || 0, workspaceId),
    queryFn: () => fetchMobileAppById(id!, workspaceId),
    enabled: !!id,
    ...options,
  });
};
